import React, { Component } from "react";
import { View, TouchableHighlight, ScrollView, Platform } from "react-native";
import Text from "./TextFont";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { connect } from "react-redux";
import ArTheme from "../argon-ui/Theme";
import * as ElevatorsAction from "../actions/ElevatorActions";
import {
  faLockAlt,
  faSortDown,
  faSortUp,
} from "../../assets/consts/faCharCodes";
import { translate } from "../locales/translate";
import { HStack } from "native-base";
import Switch from "../components/ToggleSwitch";
import Spinner from "./Spinner";
class ElevatorPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accessToken: null,
      elevatorDirectionToUp: "1",
      elevatorDirectionToDown: "2",
      requestedFloorsList: [],
      hasVIP: false,
      vipEnabled: false,
      deviceId: 0,
      deviceUId: null,
      loading: false,
    };
  }

  componentDidMount() {
    this.setState({
      accessToken: this.props.appReducer.currentServer.accessToken,
    });
  }
  getFloors(floorList) {
    if (floorList) {
      // order descending
      floorList.sort((a, b) => (a.floorLevel < b.floorLevel ? 1 : -1));
      return floorList;
    } else {
      return floorList;
    }
  }
  vipEnabledHandler = (v) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.props.vipMode(
          this.props.elevatorDeviceId,
          this.props.elevatorDeviceUId,
          v,
          this.state.accessToken
        );
      }
    );

    setTimeout(() => {
      this.setState({ loading: false });
    }, 3000);
  };
  renderVIPText = () => {
    return (
      <HStack>
        <Text>{translate("elevator.VIPMode") + " : "}</Text>
        <Text
          style={
            ({ fontWeight: "bold" },
            this.state.vipEnabled && { color: ArTheme.COLORS.ERROR })
          }
        >
          {this.state.vipEnabled
            ? translate("elevator.active")
            : translate("elevator.deactivate")}
        </Text>
      </HStack>
    );
  };
  render() {
    if (!this.props.elevatorDeviceId) {
      return null;
    }
    let elevator = this.props.DeviceReducer.list.find(
      (d) => d.deviceId == this.props.elevatorDeviceId
    );
    if (!elevator) {
      return null;
    }
    // === VIP Mode ===
    if (
      elevator?.hasVIP !== this.state.hasVIP ||
      elevator?.vipEnabled !== this.state.vipEnabled
    ) {
      this.setState({
        hasVIP: elevator.hasVIP,
        vipEnabled: elevator.vipEnabled,
        loading: false,
      });
    }
    // === get floor ===
    let floors = this.getFloors(elevator.elevatorFloors);

    if (!floors) {
      return null;
    }

    var currentFloorLabel =
      floors.filter((f) => f.floorLevel == elevator.currentFloor)[0]?.label ||
      "";
    return (
      <View
        style={{
          justifyContent: "center",
          backgroundColor: "#fff",
          alignItems: "center",
          borderRadius: 5,
          marginTop: 20,
          padding: 5,
          flex: 1,
          height: "100%",
          width: "100%",
        }}
      >
        <View
          style={{
            borderRadius: 5,
            borderColor: ArTheme.COLORS.BORDER_COLOR,
            backgroundColor: ArTheme.COLORS.BORDER_COLOR,
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "row",
            marginEnd: 30,
            marginStart: 30,
            marginBottom: 14,
            // width: WIDTH / 1.5,
            width: "100%",
            height: 70,
            marginTop: 10,
            paddingHorizontal: 15,
          }}
        >
          <View
            style={{
              flexDirection: "column",
              height: 70,
              justifyContent: "space-between",
              paddingTop: 3,
            }}
          >
            <FontAwesomeIcon
              icon={faSortUp}
              size={50}
              color={elevator.directionLabel == "UP" ? "#FFD700" : "#ccc"}
              style={{ height: 35 }}
            />
            <FontAwesomeIcon
              icon={faSortDown}
              size={50}
              color={elevator.directionLabel == "DOWN" ? "#FFD700" : "#ccc"}
              style={{
                bottom: 30,
                marginTop: Platform.OS == "web" ? -35 : 0,
              }}
            />
          </View>
          <HStack alignItems="center" space="2">
            {this.state.vipEnabled && (
              <FontAwesomeIcon
                icon={faLockAlt}
                color={ArTheme.COLORS.ERROR}
                size={30}
              />
            )}
            <Text
              style={{
                fontSize: 50,
                fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif`,
              }}
            >
              {currentFloorLabel}
            </Text>
          </HStack>
        </View>
        {/* === VIP Btn === */}
        {/*
              show all option for Admin || Support role   
              show just active vipMode text for Member role 
         */}
        {this.state.hasVIP &&
          (elevator.canEdit ? (
            <HStack w="100%" alignItems="center" space="2" my="4" px="4">
              {/* === Label === */}
              {this.state.loading ? (
                <View
                  style={{
                    width: 40,
                    height: 20,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner />
                </View>
              ) : (
                <Switch
                  isOn={this.state.vipEnabled}
                  size="small"
                  onColor={
                    this.state.vipEnabled
                      ? ArTheme.COLORS.ERROR
                      : ArTheme.COLORS.ACTIVE
                  }
                  offColor={ArTheme.COLORS.MUTED}
                  onToggle={(v) => this.vipEnabledHandler(v)}
                />
              )}
              {this.renderVIPText()}
            </HStack>
          ) : (
            this.state.vipEnabled && this.renderVIPText()
          ))}
        <ScrollView style={{ flex: 1, marginBottom: 20 }}>
          <View
            style={{
              flexDirection: "row",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            {floors &&
              floors.map((s, i) => {
                if (s.floorLevel == elevator.currentFloor) {
                  var floorIndex = this.state.requestedFloorsList.indexOf(
                    s.floorLevel
                  );
                  if (floorIndex >= 0) {
                    this.state.requestedFloorsList.splice(floorIndex, 1);
                  }
                }
                return (
                  <TouchableHighlight
                    disabled={this.state.vipEnabled}
                    key={i}
                    underlayColor={ArTheme.COLORS.BORDER}
                    onPress={() => {
                      if (!s.isPressed) {
                        this.props.callElevator(
                          elevator.deviceId,
                          elevator.deviceUId,
                          s.floorLevel,
                          this.state.accessToken
                        );
                        if (
                          !this.state.requestedFloorsList.includes(s.floorLevel)
                        ) {
                          this.state.requestedFloorsList.push(s.floorLevel);
                        }
                      }
                    }}
                    style={{
                      borderColor: s.isPressed
                        ? "blue"
                        : this.state.requestedFloorsList.includes(s.floorLevel)
                        ? "lightblue"
                        : ArTheme.COLORS.BORDER_COLOR,
                      backgroundColor: "#ffff",
                      borderWidth: 3,
                      borderRadius: 35,
                      height: 70,
                      padding: 9,
                      paddingTop: 15,
                      width: 70,
                      marginTop: 10,
                      marginBottom: 10,
                      marginEnd: 35,
                      marginStart: 25,
                    }}
                  >
                    <Text
                      style={{
                        textAlign: "center",
                        fontSize: 25,
                        fontWeight: "bold",
                        color: this.state.vipEnabled
                          ? ArTheme.COLORS.BORDER
                          : s.isPressed
                          ? "blue"
                          : this.state.requestedFloorsList.includes(
                              s.floorLevel
                            )
                          ? "lightblue"
                          : "black",
                      }}
                    >
                      {s.label}
                    </Text>
                  </TouchableHighlight>
                );
              })}
          </View>
        </ScrollView>
      </View>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    DeviceReducer: state.DeviceReducer,
    appReducer: state.AppReducer,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    callElevator: (deviceId, deviceUId, floorLevel, accessToken) => {
      dispatch(
        ElevatorsAction.Call(deviceId, deviceUId, floorLevel, accessToken)
      );
    },
    vipMode: (deviceId, deviceUId, vipEnabled, accessToken) => {
      dispatch(
        ElevatorsAction.VIPMode(deviceId, deviceUId, vipEnabled, accessToken)
      );
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ElevatorPanel);
